import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { SecurityService } from './core/security.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  @HostListener('document:dragover', ['$event'])
  onDragOverGlobal(event: DragEvent): void {
    event.preventDefault(); // Verhindert, dass der Browser eine Datei öffnet
  }

  @HostListener('document:drop', ['$event'])
  onDropGlobal(event: DragEvent): void {
    event.preventDefault(); // Verhindert, dass der Browser eine Datei öffnet
  }

  isCollapsed = true;
  isAuthenticated = false;
  user: any;
  title = 'ImageBox';
  version: string = environment.version;

  constructor(private readonly securityService: SecurityService) {}

  ngOnInit() {
    this.securityService.isAuthenticated$.subscribe((res) => {
      this.isAuthenticated = res;
    });
    this.securityService.user$.subscribe((res) => {
      this.user = res;
    });
  }

  login() {
    this.securityService.login();
  }
  async logout() {
    this.securityService.logout();
  }
}
